import { useIntl } from 'react-intl-next';

import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';
import { useEmptyFeed } from '@confluence/feed/entry-points/useEmptyFeed.ts';

export const usePostOfficeHomeBannerEligible = () => {
	const { hasFeed } = useEmptyFeed();

	const { locale } = useIntl();
	const isEnglishLocale = locale.toLowerCase().startsWith('en');

	const isFeedEligible = hasFeed;
	const isLocaleEligible = fg('post-office_confluence-home-banner-v2-locale-check')
		? isEnglishLocale
		: true;

	// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/post_office_confluence_home_banner_experiment_-_v2/setup
	return {
		isEligible:
			isFeedEligible &&
			isLocaleEligible &&
			expValEquals('post_office_confluence_home_banner_experiment_-_v2', 'cohort', 'variation'),
	};
};
